export const objectToParams = (object) => {
  let params = ''

  for (const [key, value] of Object.entries(object)) {
    params += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
  }

  return params
}

export const getParamsFromUrl = (url) => {
  const params = new URLSearchParams(new URL(url).search)
  const decodedParams = {}

  params.forEach((value, key) => {
    decodedParams[key] = decodeURIComponent(value)
  })

  return decodedParams
}
